module.exports = __webpack_public_path__ + "static/img/star4.2fff4612.png";